/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Check_Upload_LabelInputs */

const en_cv_check_upload_label = /** @type {(inputs: Cv_Check_Upload_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload resume (PDF)`)
};

const de_cv_check_upload_label = /** @type {(inputs: Cv_Check_Upload_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenslauf hochladen (PDF)`)
};

/**
* | output |
* | --- |
* | "Upload resume (PDF)" |
*
* @param {Cv_Check_Upload_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cv_check_upload_label = /** @type {((inputs?: Cv_Check_Upload_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Check_Upload_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_check_upload_label(inputs)
	return en_cv_check_upload_label(inputs)
});